module.exports = __webpack_public_path__ + "img/pressure_Off.c35be1ed.png";